export const SCROLL_INTO_ELEMENT = 'SCROLL_INTO_ELEMENT';
export function scrollIntoElement(data) {
  return {
    type: SCROLL_INTO_ELEMENT,
    id: data.id,
    parentId: data.parentId,
    itemType: data.type,
  };
}

export const CLEAR_SCROLL_TO = 'CLEAR_SCROLL_TO';
export function clearScrollTo() {
  return {
    type: CLEAR_SCROLL_TO,
  };
}



// WEBPACK FOOTER //
// ./src/store/scroll/actions.js